





















import { execute } from 'library/services/shopify/storefront'
import productCardQuery from 'library/queries/shopify/fragments/product-card.gql'
import getCraftDisplay from 'library/queries/craft/get-products-display.gql'
import ProductCard from '../../../globals/cards/product/product-card'
import breakpoints from 'library/assets/vars/breakpoints'

export default

	props:
		product: Object

	components: { ProductCard }

	data: ->
		recommendations: []
		currentSlide: 0

		config:
			slidesPerPage: 3
			showDots: true
			gutter: 0

			responsive: [
				{
					maxWidth: parseInt breakpoints.tablet
					slidesPerPage: 2
				}
				{
					peekLeft: 'var(--peek)'
					peekRight: 'var(--peek)'
					maxWidth: parseInt breakpoints.mobile
					slidesPerPage: 1
				}
			]

	fetch: ->

		# Lookup recommendations for that product
		{ recommendations } = await execute
			variables: id: @productId
			query: '''
				query ($id: ID!) {
					recommendations: productRecommendations(productId: $id) {
						...productCard
					}
				}
			''' + productCardQuery

		productHandles = recommendations.map (product) -> product.handle

		craftRecommendations = await @$craft.getEntries
			query: getCraftDisplay
			variables: handles: productHandles

		craftRecommendationsMap = {}

		craftRecommendations.forEach (product) ->
			craftRecommendationsMap[product.slug] = product.hidden

		@recommendations = recommendations.filter (product) ->
			craftRecommendationsMap[product.handle] != true

	computed:

		# If a bundle, choose a random product to get recommendations from
		productId: ->
			unless @product.isBundle
			then @product.id
			else @product.variants[0]?.product.id


	methods:

		updateCurrentSlide: ({index: @currentSlide}) -> return


